// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout-module--wrapper--1TYsl","fixedWidth":"layout-module--fixed-width--225vH","main":"layout-module--main--2yme8","fixedHeight":"layout-module--fixed-height--KRQMl"};